"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableauExpressionFormatter = void 0;
const tslib_1 = require("tslib");
const tableau_expression_parser_js_1 = require("@tableau/tableau-expression-parser-js");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const react_1 = tslib_1.__importDefault(require("react"));
class TableauExpressionFormatter extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.renderToken = (token, index) => {
            if (token.text) {
                const text = token.text;
                switch (token.type) {
                    case tableau_expression_parser_js_1.TableauExpressionLexer.COMMENT:
                        return this.renderTokenText(text, index, stringClass);
                    case tableau_expression_parser_js_1.TableauExpressionLexer.FIELDNAME:
                        return this.renderFieldName(text, index);
                    case tableau_expression_parser_js_1.TableauExpressionLexer.IDENTIFIER:
                        return this.renderIdentifier(text, index);
                    case tableau_expression_parser_js_1.TableauExpressionLexer.STRINGLITERAL:
                        return this.renderTokenText(text, index, stringClass);
                    case tableau_expression_parser_js_1.TableauExpressionLexer.LCBRACK:
                    case tableau_expression_parser_js_1.TableauExpressionLexer.RCBRACK:
                    case tableau_expression_parser_js_1.TableauExpressionLexer.COLON:
                    case tableau_expression_parser_js_1.TableauExpressionLexer.FIXED:
                    case tableau_expression_parser_js_1.TableauExpressionLexer.INCLUDE:
                    case tableau_expression_parser_js_1.TableauExpressionLexer.EXCLUDE:
                        return this.renderTokenText(text, index, functionClass);
                    default:
                        return this.renderTokenText(text, index);
                }
            }
            else {
                return null;
            }
        };
    }
    render() {
        const tokens = (0, tableau_expression_parser_js_1.tokensFromTableauExpression)(this.props.expression);
        return react_1.default.createElement("span", { className: expressionClass }, tokens.map(this.renderToken));
    }
    renderFieldName(text, index) {
        const name = (0, tableau_expression_parser_js_1.trimBrackets)(text);
        return this.renderFieldOrParameter(name, text, index);
    }
    renderIdentifier(text, index) {
        const name = text;
        return this.renderFieldOrParameter(name, text, index);
    }
    renderFieldOrParameter(name, text, index) {
        const fieldInfo = getFieldByName(name, this.props.fields);
        if (fieldInfo) {
            return (react_1.default.createElement("a", { key: index, className: fieldNameClass, href: this.props.makeFieldUrl(fieldInfo.id), target: this.props.openLinksInNewTab ? '_blank' : undefined, rel: 'noreferrer' }, text));
        }
        else {
            const parameterInfo = getParameterByName(name, this.props.parameters);
            if (parameterInfo) {
                return this.renderTokenText(text, index, parameterClass);
            }
            else {
                return this.renderTokenText(text, index);
            }
        }
    }
    renderTokenText(text, index, className) {
        return react_1.default.createElement("span", { key: index, className: className }, text);
    }
}
exports.TableauExpressionFormatter = TableauExpressionFormatter;
const fieldNameStyle = {
    color: '#f18a34',
    textDecoration: 'none',
    $nest: {
        '&:hover': {
            textDecoration: 'underline',
        },
    },
};
const functionStyle = {
    color: '#377e9c',
};
const parameterStyle = {
    color: '#936eb0',
};
const stringStyle = {
    color: '#717171',
};
const fieldNameClass = (0, vizportalclient_common_components_1.cssClass)('TableauExpression_FieldName', fieldNameStyle);
const functionClass = (0, vizportalclient_common_components_1.cssClass)('TableauExpression_Function', functionStyle);
const parameterClass = (0, vizportalclient_common_components_1.cssClass)('TableauExpression_Parameter', parameterStyle);
const stringClass = (0, vizportalclient_common_components_1.cssClass)('TableauExpression_String', stringStyle);
const expressionStyle = {
    fontFamily: 'Courier New, monospace',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    $nest: {
        [`a.${fieldNameClass}`]: {
            color: '#f18a34',
        },
    },
};
const expressionClass = (0, vizportalclient_common_components_1.cssClass)('TableauExpression_Expression', expressionStyle);
function getFieldByName(name, fields) {
    if (fields) {
        for (const fieldInfo of fields) {
            if (fieldInfo.name && fieldInfo.name === name) {
                return fieldInfo;
            }
        }
    }
    return null;
}
function getParameterByName(name, parameters) {
    if (parameters) {
        for (const parameterInfo of parameters) {
            if (parameterInfo.name && parameterInfo.name === name) {
                return parameterInfo;
            }
        }
    }
    return null;
}
//# sourceMappingURL=TableauExpressionFormatter.js.map